var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"},on:{"enter":function($event){return _vm.cb('enter',$event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }